import React from 'react';
import {
  CSRF_TOKEN
} from '../../lib/helpers';

const ParticipantForm = ({
}) => {
  return (
    <React.Fragment>
      <div className='Main__Wrapper'>
        <div className='MainHeader'>
          <div className='MainHeader__left'>
            <h2 className='MainHeader__h2'>Add Participants</h2>
          </div>
        </div>

        <div className='Container'>
          <div className='Container__row' style={{ gridTemplateColumns: '2fr 1fr' }}>
            <div className='Container__col'>
              <form method="post" encType='multipart/form-data' action={`/${gon.currentProvider}/wallet_beta_participants`} >
                <input type="hidden" name="authenticity_token" value={CSRF_TOKEN} />
                <div className='Container__form'>
                  <label className='User__form__label'>
                    Enter User ID and Email
                    (<small>One User ID, Email per line</small>)
                    <span className="req">*</span>
                  </label>

                  <textarea
                    className='Input'
                    name='participants'
                    rows={20}
                    placeholder='13353,user1@example.com&#10;212121,user2@example.com&#10;123145,user3@example.com'
                    required
                  />

                  <button type="submit" className='Button Button--blue'>
                    Submit
                  </button>
                </div>
              </form>
            </div>
            <div className='Container__col'>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  )
}

export default ParticipantForm;
